module.exports = __webpack_public_path__ + "img/838.99688369.png";